import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Publicaciones from './pages/Publicaciones';
import NuevaPublicacion from './pages/NuevaPublicacion';
import DetallePublicacion from './pages/DetallePublicacion';
import Ofertas from './pages/Ofertas';
import Clientes from './pages/Clientes';
import Usuarios from './pages/Usuarios';
import Reportes from './pages/Reportes';
import Sucursales from './pages/Sucursales';
import Mensajes from './pages/Mensajes';
import Auditoria from './pages/Auditoria';
import Blacklist from './pages/Blacklist';
import TipoGanados from './pages/TipoGanados';
import CierresAdjudicacion from './pages/CierresAdjudicacion';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="publicaciones" element={<Publicaciones />} />
                <Route path="mis-publicaciones" element={<Publicaciones isMisPublicaciones={true} />} />
                <Route path="publicaciones/nueva" element={<NuevaPublicacion />} />
                <Route path="publicaciones/:id" element={<DetallePublicacion />} />
                <Route path="ofertas" element={<Ofertas />} />
                <Route path="clientes" element={<AdminRoute><Clientes /></AdminRoute>} />
                <Route path="usuarios" element={<AdminRoute><Usuarios /></AdminRoute>} />
                <Route path="sucursales" element={<AdminRoute><Sucursales /></AdminRoute>} />
                <Route path="mensajes" element={<AdminRoute><Mensajes /></AdminRoute>} />
                <Route path="reportes" element={<AdminRoute><Reportes /></AdminRoute>} />
                <Route path="auditoria" element={<AdminRoute><Auditoria /></AdminRoute>} />
                <Route path="blacklist" element={<AdminRoute><Blacklist /></AdminRoute>} />
                <Route path="tipoGanados" element={<AdminRoute><TipoGanados /></AdminRoute>} />
                <Route path="cierres" element={<AdminRoute><CierresAdjudicacion /></AdminRoute>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;